var AuthAPI = require("../common/api/auth");
var AuthStore = module.exports = require("../common/auth");

AuthStore.on("refresh", function(cb) {
  AuthAPI.refresh().then(cb);
});
